import * as actionTypes from '../constants/programsCompanies';

const initialState = {
	selectedSellers: [],
	updated: false
};

const initialAction = {
	type: '',
	payload: {},
	message: ''
};

const ProgramsCompanies = (state = initialState, action = initialAction) => {
	switch (action.type) {
		case actionTypes.UPDATE_SELECTED_SELLERS:
			return {
				...state,
				selectedSellers: action.payload.selectedSellers
			};
		case actionTypes.GET_UPDATED_SELLERS:
			return {
				...state,
				updated: !state.updated
			};
		default:
			return state;
	}
};

export default ProgramsCompanies;
